var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandUrLogoWhite = function SvgBrandUrLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M149.397 116.531c9.241-5.882 15.426-16.16 15.292-27.802.209-18.157-14.941-33.015-33.099-33.015H87.234v58.294c0 8.57-5.955 13.76-13.3 13.76s-13.301-5.19-13.301-13.76V55.714H36.515v55.121c0 24.338 16.753 38.337 37.419 38.337s37.418-13.999 37.418-38.337V76.31h17.37c7.304 0 13.486 5.717 13.702 13.018.223 7.586-5.881 13.826-13.418 13.826h-14.499l28.609 44.267h26.264zM200 100c0 55.23-44.773 100-100 100C44.772 200 0 155.228 0 100S44.772 0 100 0c55.227 0 100 44.772 100 100"
  })));
};
export default SvgBrandUrLogoWhite;